/**
 * Role-based landing path after login or when visiting "/".
 * All faculty roles land on `/faculty/dashboard` (CBC sees the coding insights view there; regular faculty see the teaching snapshot).
 *
 * @param {string | undefined} role - user.role from auth
 * @param {{ role?: string, subtype?: string, facultyType?: string } | null | undefined} [_user] - reserved for future subtype logic
 * @returns {string}
 */
export function getDefaultRoute(role, _user) {
  if (!role) return '/login';

  if (role === 'faculty' || role === 'cbcfaculty') {
    return '/faculty/dashboard';
  }

  switch (role) {
    case 'admin':
      return '/admin/overview';
    case 'student':
      return '/student/home';
    default:
      return '/login';
  }
}
